import { Api } from '../helpers';

const userModel = {
  getUserData(params) {
    const queryParams = params;
    const path = 'user/get_basic_info';
    return Api.get({ path, queryParams });
  },

  getOrderBillDetails(params) {
    const queryParams = params;
    const path = 'order/get_bill';
    return Api.get({ path, queryParams });
  },

  downloadOrderInvoice(params) {
    const queryParams = params;
    const path = 'order/download_invoice';
    return Api.get({ path, queryParams });
  },

  getGoldDetails(params) {
    const queryParams = params;
    const path = 'user/get_gold_info';
    return Api.get({ path, queryParams });
  },

  unmaskUserInfo(params, type) {
    const queryParams = params;
    const path = `user/get_${type}`;
    return Api.get({ path, queryParams });
  },

  getUserDelightFeatureDetails(params, url) {
    const queryParams = params;
    const path = `user/${url}`;
    return Api.get({ path, queryParams });
  },

  getDelightFeatureStatus(data, url) {
    const body = data;
    const path = `user/${url}`;
    return Api.post({ path }, { body });
  },
  getUserContext(params) {
    const queryParams = params;
    const path = `user/get_profile`;
    return Api.get({ path, queryParams });
  },
  getCarts(queryParams) {
    const path = `user/get_carts_v2`;
    return Api.get({ path, queryParams });
  },
  blockUser(data) {
    const path = `user/block`;
    return Api.put({ path }, { body: data });
  },
  unBlockUser(data) {
    const path = `user/unblock`;
    return Api.put({ path }, { body: data });
  },
  userBlockStatus(userId) {
    const queryParams = { user_id: userId };
    const path = `user/block_status`;
    return Api.get({ path, queryParams });
  },

  userPreviousAddresses(params = {}) {
    const queryParams = params;
    const path = `user/get_previous_address`;
    return Api.get({ path, queryParams });
  },
  userUpadtedAddressDetails(params = {}) {
    const queryParams = params;
    const path = `user/get_address_update_history`;
    return Api.get({ path, queryParams });
  },
  userGetRoleInfo(params = {}) {
    const queryParams = params;
    const path = `user/get_role_properties`;
    return Api.get({ path, queryParams });
  },
};

export default userModel;
